import { render, staticRenderFns } from "./FirmGroupCreate.vue?vue&type=template&id=e874e218"
import script from "./FirmGroupCreate.vue?vue&type=script&lang=js"
export * from "./FirmGroupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports